/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Agentiq.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AccessControlOkResponse,
  AgentAccessPolicyDto,
  ApiErrorResponse,
  SaveAccessPolicyRequest
} from '../control-api.schemas';

import { orvalControlFetch } from '../../orval-fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getGetApiAgentsAgentIdAccessPolicyUrl = (agentId: string,) => {




  return `/api/agents/${agentId}/access-policy`
}

export const getApiAgentsAgentIdAccessPolicy = async (agentId: string, options?: RequestInit): Promise<AgentAccessPolicyDto> => {

  return orvalControlFetch<AgentAccessPolicyDto>(getGetApiAgentsAgentIdAccessPolicyUrl(agentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetApiAgentsAgentIdAccessPolicyQueryKey = (agentId: string,) => {
    return [
    `/api/agents/${agentId}/access-policy`
    ] as const;
    }


export const getGetApiAgentsAgentIdAccessPolicyQueryOptions = <TData = Awaited<ReturnType<typeof getApiAgentsAgentIdAccessPolicy>>, TError = ApiErrorResponse>(agentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAgentsAgentIdAccessPolicy>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiAgentsAgentIdAccessPolicyQueryKey(agentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiAgentsAgentIdAccessPolicy>>> = ({ signal }) => getApiAgentsAgentIdAccessPolicy(agentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: !!(agentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiAgentsAgentIdAccessPolicy>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiAgentsAgentIdAccessPolicyQueryResult = NonNullable<Awaited<ReturnType<typeof getApiAgentsAgentIdAccessPolicy>>>
export type GetApiAgentsAgentIdAccessPolicyQueryError = ApiErrorResponse


export function useGetApiAgentsAgentIdAccessPolicy<TData = Awaited<ReturnType<typeof getApiAgentsAgentIdAccessPolicy>>, TError = ApiErrorResponse>(
 agentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAgentsAgentIdAccessPolicy>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAgentsAgentIdAccessPolicy>>,
          TError,
          Awaited<ReturnType<typeof getApiAgentsAgentIdAccessPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAgentsAgentIdAccessPolicy<TData = Awaited<ReturnType<typeof getApiAgentsAgentIdAccessPolicy>>, TError = ApiErrorResponse>(
 agentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAgentsAgentIdAccessPolicy>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiAgentsAgentIdAccessPolicy>>,
          TError,
          Awaited<ReturnType<typeof getApiAgentsAgentIdAccessPolicy>>
        > , 'initialData'
      >, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiAgentsAgentIdAccessPolicy<TData = Awaited<ReturnType<typeof getApiAgentsAgentIdAccessPolicy>>, TError = ApiErrorResponse>(
 agentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAgentsAgentIdAccessPolicy>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiAgentsAgentIdAccessPolicy<TData = Awaited<ReturnType<typeof getApiAgentsAgentIdAccessPolicy>>, TError = ApiErrorResponse>(
 agentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiAgentsAgentIdAccessPolicy>>, TError, TData>>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiAgentsAgentIdAccessPolicyQueryOptions(agentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






export const getPutApiAgentsAgentIdAccessPolicyUrl = (agentId: string,) => {




  return `/api/agents/${agentId}/access-policy`
}

export const putApiAgentsAgentIdAccessPolicy = async (agentId: string,
    saveAccessPolicyRequest: SaveAccessPolicyRequest, options?: RequestInit): Promise<AgentAccessPolicyDto> => {

  return orvalControlFetch<AgentAccessPolicyDto>(getPutApiAgentsAgentIdAccessPolicyUrl(agentId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      saveAccessPolicyRequest,)
  }
);}




export const getPutApiAgentsAgentIdAccessPolicyMutationOptions = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiAgentsAgentIdAccessPolicy>>, TError,{agentId: string;data: SaveAccessPolicyRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof putApiAgentsAgentIdAccessPolicy>>, TError,{agentId: string;data: SaveAccessPolicyRequest}, TContext> => {

const mutationKey = ['putApiAgentsAgentIdAccessPolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiAgentsAgentIdAccessPolicy>>, {agentId: string;data: SaveAccessPolicyRequest}> = (props) => {
          const {agentId,data} = props ?? {};

          return  putApiAgentsAgentIdAccessPolicy(agentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutApiAgentsAgentIdAccessPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof putApiAgentsAgentIdAccessPolicy>>>
    export type PutApiAgentsAgentIdAccessPolicyMutationBody = SaveAccessPolicyRequest
    export type PutApiAgentsAgentIdAccessPolicyMutationError = ApiErrorResponse

    export const usePutApiAgentsAgentIdAccessPolicy = <TError = ApiErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiAgentsAgentIdAccessPolicy>>, TError,{agentId: string;data: SaveAccessPolicyRequest}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApiAgentsAgentIdAccessPolicy>>,
        TError,
        {agentId: string;data: SaveAccessPolicyRequest},
        TContext
      > => {
      return useMutation(getPutApiAgentsAgentIdAccessPolicyMutationOptions(options), queryClient);
    }
    export const getDeleteApiAgentsAgentIdAccessPolicyUrl = (agentId: string,) => {




  return `/api/agents/${agentId}/access-policy`
}

export const deleteApiAgentsAgentIdAccessPolicy = async (agentId: string, options?: RequestInit): Promise<AccessControlOkResponse> => {

  return orvalControlFetch<AccessControlOkResponse>(getDeleteApiAgentsAgentIdAccessPolicyUrl(agentId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteApiAgentsAgentIdAccessPolicyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAgentsAgentIdAccessPolicy>>, TError,{agentId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiAgentsAgentIdAccessPolicy>>, TError,{agentId: string}, TContext> => {

const mutationKey = ['deleteApiAgentsAgentIdAccessPolicy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiAgentsAgentIdAccessPolicy>>, {agentId: string}> = (props) => {
          const {agentId} = props ?? {};

          return  deleteApiAgentsAgentIdAccessPolicy(agentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiAgentsAgentIdAccessPolicyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiAgentsAgentIdAccessPolicy>>>

    export type DeleteApiAgentsAgentIdAccessPolicyMutationError = unknown

    export const useDeleteApiAgentsAgentIdAccessPolicy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiAgentsAgentIdAccessPolicy>>, TError,{agentId: string}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiAgentsAgentIdAccessPolicy>>,
        TError,
        {agentId: string},
        TContext
      > => {
      return useMutation(getDeleteApiAgentsAgentIdAccessPolicyMutationOptions(options), queryClient);
    }
